// extracted by mini-css-extract-plugin
export default {"terminalInputWrapper":"TerminalInput_terminalInputWrapper__n5mrG","inputForm":"TerminalInput_inputForm__c9vhY","terminalInput":"TerminalInput_terminalInput__zInwr"};